<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="SalesForecastItemsTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :show_toolbar_state="true" :isBusy="isBusy"
        :hb_table_class="'hb_table_sfd_items_class1'" :table_height_adjust="-8" :loading_width="40"
        :show_toolbar_button="[0, 0, 1, 1, 0]" @on_query="on_query" @state_change="state_change"
        @tool_invoke="tool_invoke" :show_email="true" @email_invoke="SendEmail"
        tableref="f7aaeb8f3ffd4ebd912ea11a29363932">
        <template #query>
          {{ $t("common.label_forecast_order_num") }}：<el-input clearable size="small" style="width: 150px"
            v-model="ForecastSalesId"></el-input>
          {{ $t("common.customer") + $t("common.num") }}：<el-input clearable size="small" style="width: 150px"
            v-model="CustAccountId"></el-input>
          {{ $t("common.customer") + $t("common.name") }}：<el-input clearable size="small" style="width: 200px"
            v-model="CustAccountName"></el-input>
        </template>
        <template #toolbar>
          <el-checkbox :label="$t('common.my_approval')" v-model="onlyMyApproved" class="ml-2"
            @change="myApproveChange"></el-checkbox>
          <!-- <el-checkbox :label="$t('common.only_uncancel')" v-model="onlyNotCancel" class="ml-2" @change="notCancel"></el-checkbox> -->
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as commonController from "../../controllers/commonController"
import * as OrderForecastDispatchItemsController from "../../controllers/sd/OrderForecastDispatchItemsController"
import * as OrderForecastDispatchSearchController from "../../controllers/sd/OrderForecastDispatchSearchController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import * as notify_template from "../../shared/notify_template"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"

export default {
  name: "OrderForecastDispatchItems",
  components: {
    BaseContainer,
    TableMain,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_forecast_dispatch",
      },
      fields: OrderForecastDispatchItemsController.fields.default,

      CustAccountName: "",
      CustAccountId: "",
      ForecastSalesId: "",
      isBusy: false,
      all_role_users: [],
      his_order_list: [],
      all_role_list: [],
      onlyMyApproved: false,
      onlyNotCancel: false,
    }
  },
  async created() {
    await this.getAllRoles()
    await this.getAllRoleUsers()
  },
  methods: {
    async getAllRoles() {
      let _dt = await RoleManageController.methods.GetRoleList()
      this.all_role_list = _.filter(_dt, { is_sys: false, is_valid: true })
    },
    async getAllRoleUsers() {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "e-get_all_rolecode_username",
      // ]);
      // if (!ckp) {
      //   return;
      // }
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 查询
    async on_query(set_data, date_range) {
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "e-get_sf_item_dispatch",
      // ]);
      // if (!ckp) {
      //   return;
      // }
      this.isBusy = true
      let _fromDate = "",
        _toDate = ""
      let _params = {}
      if (this.CustAccountName != "") {
        _params.CustAccountName = this.CustAccountName
      }
      if (this.CustAccountId != "") {
        _params.CustAccountId = this.CustAccountId
      }
      if (this.ForecastSalesId != "") {
        _params.ForecastSalesId = this.ForecastSalesId
      }
      if (
        !_.isNull(date_range) &&
        this.CustAccountId == "" &&
        this.ForecastSalesId == "" &&
        this.CustAccountName == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
      }
      set_data([])
      let _result = await OrderForecastDispatchItemsController.methods.getData(
        _params
      )
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.his_order_list = _result[0]
        _.each(_result[0], (t) => {
          this.getApprover(t)
        })
        set_data(_.orderBy(_result[0], ["createdDateTime"], ["desc"]))
      }
      this.myApproveChange()
      this.isBusy = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSFDispatchApprover",
        "SFDispatchApprover",
        t.fcCheckSFDApproved
      )
    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      const _this = this
      // let ckp = await this.$checkP.checkOwnPrivileges([
      //   "e-get_approve_status",
      //   "e-CheckSFApproved",
      //   "e-update_approve_status",
      //   "a-sPlant_OrderForecast_Dispatch",
      //   "u-sPlant_OrderForecast_Dispatch",
      //   "e-update_sfl_validremain",
      //   "h-interface_invoke",
      //   "x-checkinterfaceresult",
      // ]);
      // if (!ckp) {
      //   cb(false);
      //   return;
      // }

      if (data.selected_items.length == 0) {
        _this.msgToasts(_this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      // if (data.state === "unapproved") {
      //   let is_my_data = true;
      //   _.each(data.selected_items, (t) => {
      //     if (
      //       t.create_by &&
      //       t.create_by != _this.$store.state.biz_data.userInfo.user_id
      //     ) {
      //       is_my_data = false;
      //     }
      //   });
      //   if (!is_my_data) {
      //     _this.msgToasts("抱歉，您不是派发的创建人，不能反审派发！");
      //     cb(false);
      //     return;
      //   }
      // }
      ///检查是否已经审批或反审
      let _state = data.state == "approved" ? true : false
      if (
        _this.checkIsApproved(data.selected_items, "fcCheckSFDApproved", _state)
      ) {
        _this.msgToasts(_this.$t("notify.has_approved_or_unapproved"))
        cb(false)
        return
      }
      ///检查派发供应商是否包含物料
      let vi_check_list = []
      _.each(data.selected_items, (t) => {
        if (t._error && !_.includes(vi_check_list, t.AccountNum)) {
          vi_check_list.push(t.AccountNum)
        }
      })
      if (vi_check_list.length > 0) {
        _this.msgToasts(_this.$t("common.provider") + "：" + _.join(vi_check_list, "，") + _this.$t("common.invent") + _this.$t("common.not_exist") + "！", "info")
        cb(false)
        return
      }

      ///检查是否有该权限
      let _check_list = await _this.checkApproveStatus()
      if (_check_list.length > 0 && data.state == "approved") {
        _this.msgToasts(
          _this.$t("notify.not_privileges") + "（" + _.join(_check_list, "，") + "）",
          "error"
        )
        cb(false)
        return
      }
      if (data.state === "approved" || data.state === "unapproved") {
        let _msg = data.state == "approved" ? "审批" : "反审"
        _this.msgModal(_this.$t("notify.is_continue")).then(async (v) => {
          if (v) {
            const loading = _this.$loading({
              lock: true,
              text: _this.$t("notify.waiting"),
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            })

            let _group_sf_order = _.groupBy(
              data.selected_items,
              "ForecastSalesId"
            )

            for (let i in _group_sf_order) {
              ///检查订单是否审核
              let _is_order_approved =
                await OrderForecastDispatchSearchController.methods.checkOrderIsApproved(
                  { salesForecastId: _group_sf_order[i][0].order_forecast_id }
                )
              if (!_.isNull(_is_order_approved) && !_is_order_approved.state) {
                _this.msgToasts(_is_order_approved.message, "info")
                cb(false)
                loading.close()
                return
              }
            }
            let _state = data.state == "approved" ? true : false
            let res_msg = []
            let res_ax_msg = []
            for (let j in _group_sf_order) {
              let _params_list = []
              let _p = { state: _state, update_valid_data: [] }
              let _list = _.cloneDeep(_group_sf_order[j])
              ///1、审批参数
              _p.approve_data = await _this.getApproveStatusParams(
                _list,
                _state
              )
              ///2、订单明细剩余数量参数
              _.each(_list, (t) => {
                _p.update_valid_data.push({
                  id: t.OrderForecast_Line_id,
                })
              })

              ///3、AX接口参数
              ///判定是否是公司(公司才调用ax)
              let ax_list = []
              _.each(_list, (t) => {
                let _company = _.find(
                  _this.$store.state.biz_data.baseData.CompanyInfo,
                  { VenderAccountNum: t.AccountNum }
                )

                console.log({ c: _this.$store.state.biz_data.baseData.CompanyInfo, _list })

                if (_company) {
                  t.dataArea = _company.DataArea
                  ax_list.push(t)
                }
              })
              let _active = data.state == "approved" ? "Yes" : "No"
              _p.ax_params = _this.getAXParams(ax_list, "", _active, 0)
              _p.ax_list = ax_list
              _params_list.push(_p)

              let result = await OrderForecastDispatchSearchController.methods.approveListData(_params_list)
              if (!_.isNull(result)) {
                if (result.state) {
                  if (_state) {
                    ///修改ax返回数据
                    let _rdata = _.filter(result.data, {
                      Code: "data/u/sPlant_OrderForecast_Dispatch",
                    })
                    for (let m in _rdata) {
                      let rt = _rdata[m].Result.Data[0][0]
                      if (rt) {
                        let _list_m = _.find(data.selected_items, {
                          id: rt.id,
                        })
                        if (_list_m) {
                          _list_m.AXId = rt.AXId
                        }
                      }
                    }
                  }
                  _.each(_list, (a) => {
                    let t = _.find(data.selected_items, { id: a.id })
                    t.fcCheckSFDApproved = _state
                    for (let i in _params_list) {
                      let _update_status_list = _params_list[i].approve_data
                      let _ap_list = _.find(_update_status_list, {
                        order_dispatch_id: a.id,
                      })
                      t.fcGetSFDispatchApprover = ""
                      if (
                        _ap_list &&
                        _update_status_list &&
                        !t.fcCheckSFDApproved
                      ) {
                        t.fcGetSFDispatchApprover = _ap_list.Approver
                      }
                    }
                  })
                  let _data_list = await OrderForecastDispatchSearchController.methods.getDispatchData({ id: { in: _.map(_list, "id") } })
                  if (!_.isNull(_data_list) && _data_list && _data_list.length > 0) {
                    _.each(data.selected_items, (t) => {
                      let _m = _.find(_data_list[0], { id: t.id })
                      if (_m) {
                        _m["sf_create_by_username"] = _m.create_by_username
                        delete _m.create_by_username
                        if (_m) {
                          _this.$refs.SalesForecastItemsTable1.UpdateItems({ id: t.id }, _m)
                        }
                      }
                    })
                  }
                } else {
                  if (result.type == "ax") {
                    let _venders = _.map(_list, "AccountNum")
                    res_ax_msg.push("<hr/><div>" + _this.$t("common.provider") + _this.$t("common.num") + "：" + _venders[0] + "，" + result.message + "</div>"
                    )
                  } else {
                    let _venders = _.map(_list, "AccountNum")
                    res_msg.push("<hr/><div>" + _this.$t("common.provider") + _this.$t("common.num") + "：" + _venders[0] + "，" + result.message + "</div>"
                    )
                  }
                }
              }
            }

            if (res_msg.length == 0 && res_ax_msg.length == 0) {
              _this.msgToasts(_this.$t("notify.action_successfully"), "success")
              cb(true)
            } else {
              let _msg = ""
              if (res_msg.length > 0) {
                _msg += _this.$t("notify.action_unsuccessfully") + _this.$t("notify.error_info") + "：" + _.join(res_msg, " ")
              }
              if (res_ax_msg.length > 0) {
                _msg += _this.$t("notify.ax_error") + "：" + _.join(res_ax_msg, " ")
              }
              _this.msgToasts(_msg, "info", null, true)
              cb(false)
            }

            if (_state) {
              ///审批成功后发邮件
              let _emailList = _.filter(data.selected_items, {
                fcCheckSFDApproved: true,
              })
              let _ep = {
                notify_type: "sfd_approve_pass",
                subject: "sfd_approve_pass",
                idx: "id",
              }
              await _this.sendEmailAfterApproved(_emailList, _ep)
            }
            await commonController.methods.saveUserConfirmAction(`${data.state}_confirm`, 'OrderForecastDispatchItem', data, this)
            loading.close()
          }
          else {
            await commonController.methods.saveUserConfirmAction(`${data.state}_cancel`, 'OrderForecastDispatchItem', data, this)
          }
        })
      } else if (data.state == "cancel" || data.state == "uncancel") {
        ///取消，反取消
        let _state = data.state == "cancel" ? true : false
        let _msg = data.state == "cancel" ? "取消" : "反取消"

        ///检查
        let is_check_ok = _this.checkValidData(_.cloneDeep(data.selected_items))
        if (!is_check_ok) {
          cb(false)
          return
        }

        _this.msgModal(_this.$t("notify.is_continue")).then(async (v) => {
          if (v) {
            const loading = _this.$loading({
              lock: true,
              text: _this.$t("notify.saveing"),
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            })

            let res_msg = []
            let isValid = _state ? 1 : 0
            let select_list = _.cloneDeep(data.selected_items)
            for (let i in select_list) {
              let _list = []
              _list.push(select_list[i])
              let _update_soline_form_list = []
              _.each(_list, (t) => {
                if (
                  !_.includes(
                    _.map(_update_soline_form_list, "id"),
                    t.OrderForecast_Line_id
                  )
                ) {
                  _update_soline_form_list.push({
                    id: t.OrderForecast_Line_id,
                  })
                }
              })

              ///整理ax参数
              let ax_list = _.filter(_list, function (t) {
                return !_.isNull(t.AXId) && !_.isEmpty(t.AXId)
              })
              let ax_params = _this.getAXParams(
                ax_list,
                "Update",
                "Yes",
                isValid
              )

              ///执行审核
              let update_params = []
              _.each(_list, (t) => {
                update_params.push({
                  id: t.id,
                  qty: t.qty,
                  OrderForecast_Line_id: t.OrderForecast_Line_id,
                  is_cancel: isValid,
                })
              })

              let _params = {
                update_data: update_params,
                update_soline_form_list: _update_soline_form_list,
                ax_params: ax_params,
              }

              let result =
                await OrderForecastDispatchSearchController.methods.cancelData(_params, this)
              if (!_.isNull(result)) {
                if (result.state == true) {
                  ///成功
                  _.each(_params.update_data, (t) => {
                    let m = _.find(data.selected_items, { id: t.id })
                    if (m) {
                      m.is_cancel = _state
                    }
                  })
                } else {
                  res_msg.push("<hr/><div>" + result.message + "</div>")
                }
              }
            }

            if (res_msg.length == 0) {
              _this.msgToasts(_this.$t("notify.action_successfully"), "success")
              cb(true)
            } else {
              _this.msgToasts(_.join(res_msg, " "), "info", null, true)
              cb(false)
            }

            loading.close()
          }
        })
      }
    },
    checkValidData(_list) {
      let is_check_ok = true
      ///检查是否是已审批数据
      let is_approved_data = true
      _.each(_list, (t) => {
        if (!t.fcCheckSFDApproved) {
          is_approved_data = false
        }
      })
      if (!is_approved_data) {
        this.msgToasts(this.$t("notify.is_not_all_approved"), "info")
        is_check_ok = false
      }
      return is_check_ok
    },
    ///审批后发邮件
    async sendEmailAfterApproved(data, _p) {
      let _groupby_user = _.groupBy(data, "create_by_username")
      ///发邮件给创建人
      await this.exSendEmailAfterApproved(_groupby_user, _p)
      ///根据派发人发送邮件
      let list = []
      for (let i in data) {
        let _m = _.cloneDeep(data[i])
        let vend = _.find(this.$store.state.biz_data.baseData.Vender, {
          AccountNum: _m.AccountNum,
        })
        if (vend && vend.EmailNotifier && vend.EmailNotifier != "") {
          //邮件通知人
          let _dt = _.split(vend.EmailNotifier, ",")
          if (_dt && _dt.length > 0) {
            _.each(_dt, (n) => {
              _m.create_by_username = n
              list.push(_.cloneDeep(_m))
            })
          }
        }
      }
      if (list.length > 0) {
        let _groupby_dispatch_user = _.groupBy(list, "create_by_username")
        await this.exSendEmailAfterApproved(_groupby_dispatch_user, _p)
      }
    },
    async exSendEmailAfterApproved(_list, _p) {
      let notify_list = []
      for (let d in _list) {
        let lang_code = notify_template.methods.getUserLangCode(this, d)
        let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

        let _email_params = {
          notify_type: _p.notify_type,
          subject: email_template[_p.subject],
          create_by_username: d,
          list: _list[d],
          idx: _p.idx,
        }
        let _ep = notify_template.methods.getApprovedEmailTemplate(_email_params, this)
        notify_list.push(_ep)
      }
      if (notify_list.length > 0) {
        await commonController.methods.sendOrCancelNotify("add", notify_list)
      }
    },
    async getApproveStatusParams(_list, _state) {
      let _update_status_list = []

      let _roles = []
      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      for (let i in _list) {
        _list[i].is_approved = _state
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesForcastDispatch",
          ApproveType: "",
          ItemId: _list[i].id,
        })
        _.each(_as_result[0], (at) => {
          if (at) {
            if (_state) {
              if (
                _.includes(_roles, at.Approver) ||
                this.$global.global_data.local_username == at.Approver
              ) {
                at.is_approved = _state
                at.username = this.$global.global_data.local_username
                at.order_dispatch_id = _list[i].id
                at.userId = this.$store.state.biz_data.userInfo.user_id
                _update_status_list.push(at)
              }
            } else {
              // if (
              //   _.includes(_roles, at.Approver) || this.$global.global_data.local_username == at.Approver || _list[i].create_by ==
              //   this.$store.state.biz_data.userInfo.user_id
              // ) {
              //   if (at.ApproveLevel != 1 && at.Approver == "") {
              //   } else {
              //     at.is_approved = _state;
              //     at.username = this.$global.global_data.local_username;
              //     at.order_dispatch_id = _list[i].id;
              //     _update_status_list.push(at);
              //   }
              // }
              at.is_approved = false
              at.username = this.$global.global_data.local_username
              at.order_dispatch_id = _list[i].id
              at.userId = this.$store.state.biz_data.userInfo.user_id
              _update_status_list.push(at)
            }
          }
        })
      }
      return _update_status_list
    },
    ///调用ax接口
    getAXParams(_list, _Status, _ApproveStatus, _isVlid) {
      let _this = this
      let _ax_params = []
      ///根据供应商分组
      let group_by_supplier_list = _.groupBy(_list, "dataArea")
      for (let i in group_by_supplier_list) {
        let _area_list = group_by_supplier_list[i]
        let _jsonData = []
        for (let j in _area_list) {
          let t = _area_list[j]
          if (_Status == "") {
            if (_.isNull(t.AXId) || t.AXId == "") {
              if (_ApproveStatus == "No") {
                continue
              }
            }
          }
          let _temp_status = _Status
          if (_Status == "") {
            if (!_.isNull(t.AXId) && t.AXId != "") {
              _temp_status = "Update"
            } else {
              _temp_status = "Create"
            }
          }
          ///整理jsonData

          _jsonData.push({
            ItemId: t.ItemId,
            RetailVariantId: t.RetailVariantId,
            StartDate: _this.formatDate(t.delivery_date),
            EndDate: "",
            Active: _ApproveStatus,
            IsCancel: _isVlid,
            CustAccountId: t.CustAccountId,
            CurrencyCode: "CNY",
            orderId: t.ForecastSalesId, ///订单编号
            createdBy: t.create_by_username,
            SalesQty: t.qty,
            SalesUnitId: _.isEmpty(t.SalesUnitId) == true ? "个" : t.SalesUnitId,
            ModelId: t.ModelId,
            Status: _temp_status,
            AXId: t.AXId,
            SEI_CP_ReplenishmentCommit: t.SEI_CP_ReplenishmentCommit,
            WeekName: t.WeekName,
            CMForecastDispatchId: t.id
          })
        }
        _ax_params.push({
          company: i,
          jsonData: _jsonData,
        })
      }
      return _ax_params
    },
    //#endregion

    ///检查是否包含该审批权限
    async checkApproveStatus() {
      let _check_list = []
      let _roles = []

      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      let _selected_list =
        this.$refs.SalesForecastItemsTable1.GetSelectedItems()
      for (let i in _selected_list) {
        let t = _selected_list[i]
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesForcastDispatch",
          ApproveType: "",
          ItemId: t.id,
        })
        let _is_ok = true
        for (let j in _as_result[0]) {
          let at = _as_result[0][j]
          if (at) {
            if (
              _.includes(_roles, at.Approver) ||
              this.$global.global_data.local_username == at.Approver
            ) {
              _is_ok = false
            }
          }
        }
        if (_is_ok && !_.includes(_check_list, t.id)) {
          _check_list.push(t.id)
        }
      }
      return _check_list
    },
    ///检查是否已经审批或者反审
    checkIsApproved(items, code, state) {
      let _index = _.findIndex(items, (t) => {
        if (t[code] == state) {
          return t
        }
      })
      return _index > -1
    },
    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: "table_sales_order_detail",
          sheet_title: "客户",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    //#endregion
    myApproveChange() {
      let _roles = []
      let _username = this.$global.global_data.local_username
      if (this.onlyMyApproved) {
        if (this.$refs.SalesForecastItemsTable1.my_data.length == 0) {
          this.onlyMyApproved = false
          this.msgToasts(this.$t("notify.not_selected_data"), "info")
          return
        }
        if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
          _roles = _.map(
            this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
            "code"
          )
        }

        let _list = []
        _.each(this.$refs.SalesForecastItemsTable1.my_data, (t) => {
          if (
            !_.isNull(t.fcGetSFDispatchApprover) &&
            t.fcGetSFDispatchApprover
          ) {
            let name_or_role = t.fcGetSFDispatchApprover.split(",")[0]
            let _is_role = t.fcGetSFDispatchApprover.split(",")[1]
            if (_is_role == 1) {
              if (_.includes(_roles, name_or_role)) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            } else {
              if (_username == name_or_role) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            }
          }
        })
        this.$refs.SalesForecastItemsTable1.SetData(
          _.orderBy(_list, ["id"], ["desc"])
        )
      } else {
        this.$refs.SalesForecastItemsTable1.SetData(this.his_order_list)
      }
    },
    notCancel() {
      if (this.his_order_list.length == 0) {
        this.onlyNotCancel = false
        this.msgToasts(this.$t("notify.excute_search_before"), "info")
        return
      }
      if (this.onlyNotCancel) {
        let _list = _.filter(this.$refs.SalesForecastItemsTable1.my_data, {
          is_cancel: false,
        })
        this.$refs.SalesForecastItemsTable1.SetData(_list)
      } else {
        this.$refs.SalesForecastItemsTable1.SetData(this.his_order_list)
      }
    },
    ///审批邮件模板
    orderEmailTemplate(_selectedlist) {
      let _this = this

      let notify_list = []
      let group_sfl_list = _.groupBy(_selectedlist, "OrderForecast_Line_id")
      for (let i in group_sfl_list) {
        let order_line_m = group_sfl_list[i][0]
        let company_name = ""
        let _company_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
          DataArea: order_line_m.dataAreaId,
        })
        if (_company_m) {
          company_name = _company_m.CompanyName
        }
        let _params = {}
        _params.main = {
          type_name: "预测订单派发审批",
          url: window.location.protocol + "//" + window.location.host + "/sd/OrderForecastDispatch?k=" + order_line_m.ForecastSalesId,
          url_name: window.location.host + "/sd/OrderForecastDispatch?k=" + order_line_m.ForecastSalesId,
          forcast_code: order_line_m.ForecastSalesId,
          customer_name: order_line_m.CustAccountName,
          model_id: order_line_m.ModelId,
          invent_id: order_line_m.ItemId,
          invent_name: order_line_m.NameAlias,
          variant_name: order_line_m.VariantName,
          sales_qty: order_line_m.SalesQty,
          forcast_rate: order_line_m.SEI_ForecastAccuracy,
          forcast_type: order_line_m.SEI_ForecastSalesType,
          delivery_date: this.formatDate(
            order_line_m.StartDate
          ),
          sales_company: company_name,
          forcast_description: _.isNull(order_line_m.description)
            ? ""
            : order_line_m.description,
          username: this.$global.global_data.local_username,
          create_at: _this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        }

        _.each(group_sfl_list[i], async (t) => {
          let lang_code = notify_template.methods.getUserLangCode(this, t.SFDispatchApprover)
          let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

          let _notify_p = {
            category: "sfd_approve",
            idx: t.id,
            itemId: t.id,
            notify_type: "sfd_approve",
            subject: email_template["sfd_approved_be_care"],
            content: "",
          }
          _params.email_user = t.SFDispatchApprover
          _params.items = []
          _params.items.push({
            vend_num: t.AccountNum,
            vend_name: t.SEI_Name,
            qty: t.qty,
            capacity: t.Capacity,
            total_score: t.TotalScore,
            delivery_date: this.formatDate(
              t.delivery_date
            ),
            dispatch_description: "",
          })

          let _index = _.findIndex(notify_list, { idx: t.id })
          if (_index < 0) {
            _notify_p.content = notify_template.methods.getForcastDispatchTemplate(_params, this)
            notify_list.push(_notify_p)
          }
        })
      }
      return notify_list
    },
    ///send email
    SendEmail(data) {
      ///判断是否是自己创建的数据
      let is_my_data = true
      let _data =
        this.$refs.SalesForecastItemsTable1.GetSelectedItems()
      _.each(_data, (t) => {
        if (
          t.create_by &&
          t.create_by != this.$store.state.biz_data.userInfo.user_id
        ) {
          is_my_data = false
        }
      })
      if (!is_my_data) {
        this.msgToasts(this.$t("notify.not_created_by_yourself"))
        return
      }

      let _this = this
      let _list = _.orderBy(
        this.$refs.SalesForecastItemsTable1.GetSelectedItems(),
        ["id"],
        ["desc"]
      )
      if (_list.length > 0) {
        if (data.code == "add") {
          this.msgModal(this.$t("notify.is_send_email")).then(async (v) => {
            if (v) {
              let _so_ids = []
              _.each(_list, async (t) => {
                _so_ids.push(t.id)
              })

              let notify_list = []

              //====审批
              let order_email_list = _.filter(_list, {
                fcCheckSFDApproved: false,
              })
              let _order_email_temp_list = this.orderEmailTemplate(order_email_list)
              if (_order_email_temp_list.length > 0) {
                notify_list = _.union(notify_list, _order_email_temp_list)
              }

              // console.log(notify_list)
              if (notify_list.length > 0) {
                let _rsult = await commonController.methods.sendOrCancelNotify(
                  data.code,
                  notify_list
                )
                if (!_.isNull(_rsult)) {
                  _this.msgToasts(this.$t("notify.email_seccess"), "success")
                  await commonController.methods.updateEmailSendState(
                    "sfd",
                    _list
                  )
                  _.each(_list, (t) => {
                    t.is_email_send = true
                  })
                }
              } else if (_list.length > 0 && notify_list.length == 0) {
                _this.msgToasts(this.$t("notify.approved_can_not_send_email"), "info")
              }
            }
          })
        } else {
          this.msgModal(this.$t("notify.is_repeal_email")).then(async (v) => {
            if (v) {
              let notify_list = []
              _.each(_list, (t) => {
                ///普通审批邮件
                notify_list.push({
                  idx: t.id,
                  notify_type: "sfd_approve",
                })
              })
              if (notify_list.length > 0) {
                let _rsult = await commonController.methods.sendOrCancelNotify(
                  data.code,
                  notify_list
                )
                if (!_.isNull(_rsult)) {
                  _this.msgToasts(this.$t("notify.approved_email_cancel_success"), "success")
                }
              }
            }
          })
        }
      } else {
        this.msgToasts(this.$t("notify.not_data"), "info")
      }
    },
  },
}
</script>
<style>
.hb_table_sfd_items_class1 {
  /* width: auto; */
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 3600px;
}
</style>
